import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="card" style={{ maxWidth: '500px', margin: '100px auto', textAlign: 'center' }}>
      <h2>Welcome to Job Seeker</h2>
      <p>Track and manage your job applications in one place.</p>
      <p>Please log in to view your job applications.</p>
      <button 
        className="btn" 
        onClick={() => loginWithRedirect()}
        style={{ marginTop: '20px' }}
      >
        Log In
      </button>
    </div>
  );
};

export default LoginPage;